import Link from 'next/link';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import type { ISearchFallbackScenariosProps } from '..';

import { ScSearchFallbackScenario } from '../styled';

type WithdrawScenarioProps = ISearchFallbackScenariosProps;

export const WithdrawScenario: React.FC<WithdrawScenarioProps> = ({
  sendSearchResultAppearance,
  closeModal,
}) => {
  const { t } = useTranslation('lobby');

  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });
  }, []);

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>{t('searchFallback.title')}</p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href="/profile-custom/cashbox"
                  onClick={closeModal}
                />
              ),
            }}
            i18nKey="searchFallback.subtitle.withdraw"
            ns="lobby"
          />
        </p>
      </div>
    </ScSearchFallbackScenario>
  );
};
